// var API_DOMAIN = "https://giftworldsattur.zentexus.in/api";
// //var API_DOMAIN = "http://localhost/zen_online_stores/api";
// // /https://zenonlinestore.zentexus.in/

// export default API_DOMAIN;

// Use REAL hostname dynamically
const hostname = window.location.hostname || "zenonlinestore.zentexus.in";

// OR if you still want to test manually, DO NOT include https://
  //const hostname = "giftworldsattur.zentexus.in";

// Break into domain parts
let parts = hostname.split(".");

// Handle www
if (parts[0] === "www") parts.shift();

// Default tenant
const defaultSubdomain = "zenonlinestore";

let subdomain =
  parts.length > 2
    ? parts[0]               // giftworldsattur.zentexus.in
    : parts.length === 2
    ? defaultSubdomain       // zentexus.in
    : parts[0] || defaultSubdomain; // localhost case

const API_DOMAIN = `https://${subdomain}.zentexus.in/api`;

// console.log("Configured API_DOMAIN:", API_DOMAIN);
// console.log("Configured subdomain:", subdomain);

export default { API_DOMAIN, subdomain };


